// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"116": "8d58ce02","122": "21a578a4","354": "9c6094ad","36": "830872fd","365": "622a9ccc","535": "d87ce218","58": "13945c8a","633": "04dd220c","646": "1b35a709","783": "f7c901c3","819": "e160b1f5",}[chunkId] + ".js"
}